import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { DEFAULT_THEME_COLOR, normalizeThemeColor } from '../config/themeColors';
import { createArchimageTheme } from '../theme';
import { setAccentColor } from '../lib/theme';

const ThemeColorContext = createContext({
  themeColor: DEFAULT_THEME_COLOR,
  setThemeColor: () => {},
});

export function useThemeColor() {
  return useContext(ThemeColorContext);
}

export default function ArchimageThemeProvider({ themeColor: themeColorProp, children }) {
  const themeColor = useMemo(() => normalizeThemeColor(themeColorProp), [themeColorProp]);
  const [themeColorState, setThemeColorState] = useState(themeColor);

  useEffect(() => {
    setThemeColorState(themeColor);
  }, [themeColor]);

  // Synchro immédiate (getAccentColor est lu avant le useEffect dans certains écrans).
  setAccentColor(themeColorState);

  const theme = useMemo(() => createArchimageTheme(themeColorState), [themeColorState]);

  return (
    <ThemeColorContext.Provider value={{ themeColor: themeColorState, setThemeColor: setThemeColorState }}>
      <MantineProvider theme={theme} defaultColorScheme="light">
        <Notifications position="top-right" zIndex={5000} />
        {children}
      </MantineProvider>
    </ThemeColorContext.Provider>
  );
}
